import { IBLSpinLoader, PathwayItems } from '../../../components';
import { useSkill } from '../../../hooks';
import { useTranslation } from 'react-i18next';
import React from 'react';

export const SkillViewContent = ({ skillID }) => {
  const { skillCourses, skillCoursesLoaded, skillData} =
    useSkill({ skillID });

  const { t } = useTranslation('library');

  return (
    <div className="pathway">
      <div className="div-block-110">
        <div className="pathway_div">
          <div className="div-block-121"></div>
          <div className="text-block-58">
            {skillData?.data?.name}
          </div>
          <div className="div-block-75">
            <div className="p_header">
              <div className="text-block-39 wide p_t wt">
                {skillData?.data?.name}
              </div>
              <div
                className="unit-wide-description people profile_description p_t wto"
                prop-data-names="stat"
                prop-data-value-stat="32 Items - 8 sections - 7 Hours"
              >
                {skillCoursesLoaded
                  ? `${skillCourses?.length} ${' ' + t('Courses')}`
                  : ''}
              </div>
            </div>
          </div>
        </div>
        {/*{descriptionContent && (
          <div className="p_about">
            <div className="text-block-57" prop-data-names="description">
              {descriptionContent}
            </div>
          </div>
        )}*/}
      </div>
      <div className="p_outline">
        {
          !skillCoursesLoaded ? <IBLSpinLoader size={40} containerHeight={"200px"} /> : skillCourses.map((data, index) => {
            return (
              <PathwayItems key={index} data={data} index={index} />
            );
          })
        }
      </div>
    </div>
  );
};
